const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/overview/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/overview/')({
  beforeLoad: ({
    context: {
      flags
    }
  }) => {
    if (!flags.loopNewUi) {
      throw notFound();
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});